import React from 'react';

import Home from '../../../components/screens/programme/home/Home';

const HomeContainer = () => <Home />;

export default HomeContainer;
